import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.m.css";
import { Link, WithHostUrl } from "@quintype/components";
import assetify from "@quintype/framework/assetify";
import logo from "../../../../../assets/images/vikatan-logo.png";
import LatestIssues from "../latest-issues";
import AppLinks from "../app-links";
import SubscriptionLink from "../subscription-link";
import UserLogin from "../user-login";
import Icon from "../../../atoms/icon";
import { DfpAd } from "../../../atoms/dfp-ad";
const HeaderBrandRow = ({
  appStoreLinks,
  onMegaMenuToggle,
  isMegaMenuOpen,
  subscriptionLink,
  onSearchToggle,
  user,
  vikatanHosts,
  searchButtonRef
}) => {
  return (
    <div className={styles["brand-row"]}>
      <div className="container">
        <div className={`${styles["brand-row-inner-wrap"]}`}>
          <WithHostUrl>
            {({ primaryHostUrl }) => (
              <Link
                className={styles["home-link"]}
                aria-label="Vikatan"
                href={primaryHostUrl ? primaryHostUrl + "/" : "/"}
              >
                <img alt="Vikatan" src={assetify(logo)} className={styles["brand-logo"]} />
              </Link>
            )}
          </WithHostUrl>
          <div className={styles["brand-row-right"]}>
            <DfpAd
              className={`${styles["ad-top-header"]} hidden-mobile`}
              adtype="Home_MLB_Subscription"
              placement="all"
            />
            <WithHostUrl>
              {({ primaryHostUrl }) =>
                primaryHostUrl && subscriptionLink && !primaryHostUrl.match(/^https?:\/\/www.vikatan.tv/) ? (
                  <SubscriptionLink href={subscriptionLink.href} text={subscriptionLink.text} />
                ) : null
              }
            </WithHostUrl>
            <button
              aria-label="search"
              role="button"
              title="search"
              className={`${styles["search-icon"]} hidden-desktop`}
              onClick={onSearchToggle}
              ref={searchButtonRef}
            >
              <Icon type="search" className={styles["search"]} />
            </button>
            {appStoreLinks && <AppLinks appStoreLinks={appStoreLinks} className="flex-show-tablet-and-desktop" />}
            <WithHostUrl>
              {({ primaryHostUrl }) =>
                primaryHostUrl && !primaryHostUrl.match(/^https?:\/\/www.vikatan.tv/) ? (
                  <UserLogin user={user} vikatanHosts={vikatanHosts} />
                ) : null
              }
            </WithHostUrl>
            <button
              aria-label="menu toggle"
              role="button"
              onClick={e => {
                onMegaMenuToggle(e);
              }}
              className={`${styles["hamburger"]} ${isMegaMenuOpen ? styles["is-open"] : ""} hidden-desktop`}
            >
              <span className={styles["line"]} />
              <span className={styles["line"]} />
              <span className={styles["line"]} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

HeaderBrandRow.propTypes = {
  searchButtonRef: PropTypes.func,
  appStoreLinks: AppLinks.propTypes.appStoreLinks,
  latestIssues: LatestIssues.propTypes.latestIssues,
  onMegaMenuToggle: PropTypes.func,
  isMegaMenuOpen: PropTypes.bool,
  onSearchToggle: PropTypes.func,
  subscriptionLink: PropTypes.shape({
    text: PropTypes.string,
    href: PropTypes.string
  }),
  user: PropTypes.object,
  vikatanHosts: PropTypes.shape({
    login: PropTypes.string,
    subscription: PropTypes.string,
    userProfile: PropTypes.string,
    logout: PropTypes.string
  })
};

export default HeaderBrandRow;
